<template>
  <div>
    <AddGroup
      v-if="addGroupModal"
      :show="addGroupModal"
      :step1Payload="step1Payload"
      v-on:closeGroupModal="addGroupModal = false"
      @payload="updateGroup"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="successMsg"
      :heading="successHeading"
    />

    <ConfirmModal
      :msg="$t('download_report_msg')"
      :show="showConfirm"
      @submit="doStart"
      @close="showConfirm = false"
      :heading="$t('download_report')"
      :btnTxt="$t('yes_download')"
      is-yellow
    />

    <ConfirmModal
      :msg="$t('oops_download_msg')"
      :show="showOopsModal"
      :heading="$t('oops_download_heading')"
      :btnTxt="$t('ok')"
      @close="showOopsModal = false"
      @submit="showOopsModal = false"
      is-yellow
      :showSecondaryBtn="false"
    />
    <div class="page-wrapper">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading>
      <div class="page-breadcrumb">
        <div class="row">
          <div class="col-sm-5 align-self-center">
            <h6 class="font-16 font-weight-bold">
              {{ showTable ? $t("add_group") : $t("groups") }}
            </h6>
          </div>
          <div class="col-sm-7 align-self-center">
            <div class="d-flex align-items-center justify-content-end">
              <span
                v-if="
                  profile.role !== 'staff' &&
                  !showTable &&
                  canPerformAction('groups', 'export')
                "
                class="upload_download"
                @click="downloadreport"
              >
                <img src="../../assets/images/solar_download-outline.svg" />
                <span> {{ $t("download_file") }} </span>
              </span>
              <button
                v-if="
                  profile.role !== 'staff' &&
                  !showTable &&
                  canPerformAction('groups', 'addOrEdit')
                "
                @click="showTable = true"
                class="btn btn-primary"
              >
                {{ $t("add_group") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div style="padding-left: 20px; padding-right: 20px">
        <notification-box :mssg="mssg" :errorMssg="Errormssg" />
      </div>
      <div class="container-fluid mt-0">
        <div class="card">
          <div class="card-body">
            <div class="group-table" v-if="!showTable">
              <div
                class="d-flex justify-content-between align-items-center mb-4"
              >
                <p class="page-title mb-0 font-16 font-weight-bold">
                  {{ $t("All groups") }}
                </p>
                <TableSearch
                  @handleSearch="handleSearch"
                  :placeholder="$t('search_placeholder')"
                />
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="table-responsive">
                    <div
                      id="zero_config_wrapper"
                      class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
                    >
                      <div class="row" style="overflow: auto">
                        <div class="col-sm-12">
                          <table
                            id="order-listing"
                            class="table table-hover display"
                          >
                            <thead class="data-table-bg">
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    @click="headingCheckClick"
                                    :checked="isAllChecked"
                                  />
                                </th>
                                <th>{{ $t("group_name") }}</th>
                                <th>{{ $t("num_dev") }}</th>
                                <th v-if="profile.role !== 'staff'">
                                  {{ $t("num_users") }}
                                </th>
                                <!-- <th>{{ $t("avg_temp") }}</th>
                                <th>{{ $t("avg_humid") }}</th> -->
                              </tr>
                            </thead>
                            <tbody v-if="groups.length > 0">
                              <tr
                                :key="index"
                                v-for="(group, index) in activegroups"
                                @click="gotogroup(group.id)"
                                style="cursor: pointer"
                                class="user-row"
                                :class="{
                                  'data-table-bg': index % 2 !== 0,
                                }"
                              >
                                <td>
                                  <input
                                    type="checkbox"
                                    :value="group.id"
                                    @click.stop="handleCheck(group.id)"
                                    :checked="checkedGroup.includes(group.id)"
                                  />
                                </td>
                                <td>{{ group.name }}</td>
                                <td v-if="group.devices.length > 0">
                                  {{ group.devices.length }}
                                </td>
                                <td v-else>{{ $t("no_dev") }}</td>
                                <td v-if="profile.role !== 'staff'">
                                  <div v-if="group.users.length > 0">
                                    {{ group.users.length }}
                                  </div>
                                  <div v-else>{{ $t("no_user") }}</div>
                                </td>
                                <!-- <td>
                                  {{
                                    group.temperatura &&
                                      Number(group.temperature).toFixed(2)
                                  }}
                                </td>
                                <td>
                                  {{
                                    group.humidity &&
                                      Number(group.humidity).toFixed(2)
                                  }}
                                </td> -->
                              </tr>
                            </tbody>
                            <tbody class="" v-else>
                              <tr align="center">
                                <td colspan="5">
                                  <div class="col-md-6 col-lg-5 mx-auto">
                                    <img
                                      src="../../assets/images/Group 2339.png"
                                      alt=""
                                    />
                                    <h3 class="mt-3">
                                      {{ $t("no_group_yet") }}
                                    </h3>
                                    <p v-if="profile.role !== 'staff'">
                                      {{ $t("group_monitor") }}
                                    </p>
                                    <p v-else>
                                      {{ $t("ur_groups") }}
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <Pagination
                      :pageCount="pageCount"
                      :data="activegroups"
                      :sizeperpage="sizeperpage"
                      :pageNumber="pageNumber"
                      :pages="pages"
                      @goToLastPage="goToLastPage"
                      @nextPage="nextPage"
                      @handlePageChange="handlePageChange"
                      @goToFirstPage="goToFirstPage"
                      @prevPage="prevPage"
                      @onchange="onchange"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="create-group" v-else>
              <form class="p-2" @submit.prevent="createGroup">
                <div class="row">
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label>{{ $t("group_name") }}</label>
                      <input
                        type="text"
                        name="group_name"
                        v-model="group_name"
                        class="form-control"
                        required
                      />
                    </div>
                  </div>
                  <!-- <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label for="">Group Storage</label>
                      <div v-click-outside="closeDropdown">
                        <div
                          class="form-control cursor-pointer d-flex justify-content-between align-items-center data-table-bg"
                          @click="showDropdown = !showDropdown"
                        >
                          {{ storage ? dropDownName : "-- Select Storage --" }}

                          <i
                            class="fa fa-caret-down"
                            :class="{
                              'fa-caret-up': showDropdown,
                              'fa-caret-down': !showDropdown,
                            }"
                          ></i>
                        </div>
                        <div class="storage-dropdown" v-if="showDropdown">
                          <ul class="position-absolute w-100">
                            <li
                              v-for="({ img, value, name }, i) in storageTypes"
                              :key="i"
                              class="p-2 d-flex col-gap-1 align-items-center cursor-pointer font-weight-bold text-white font-16"
                              :class="{ active: value === storage }"
                              @click="
                                storage = value;
                                dropDownName = name;
                                showDropdown = false;
                              "
                            >
                              <span>
                                <div>
                                  <div v-if="value == 'others'">
                                    &#xb0;&#xb0;&#xb0;
                                  </div>
                                  <img v-else :src="img" alt="" />
                                </div>
                              </span>
                              {{ name }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
                <!-- <div class="row">
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label>{{ $t("If Others, please specify") }}</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="others"
                          :disabled="storage !== 'others'"
                          :required="storage === 'others'"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label>{{ $t("Capacity") }}</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="capacity"
                          required
                        />
                      </div>
                      <p
                        v-if="capacity && !alphanumeric(capacity)"
                        class="font-12 error"
                      >
                        {{ $t("valid-measurement") }}
                      </p>
                    </div>
                  </div>
                </div> -->

                <!-- <div class="row">
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label>{{ $t("min-temp") }}</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model.number="minTemperature"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label>{{ $t("max-temp") }}</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model.number="maxTemperature"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="row">
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label>{{ $t("min-humid") }}</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model.number="minHumidity"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label>{{ $t("max-humid") }}</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model.number="maxHumidity"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="row">
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label>{{ $t("devices_limit") }}</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model.number="devicesLimit"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label>{{ $t("users_limit") }}</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model.number="usersLimit"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div> -->
                <hr class="mt-8" />
                <p class="my-4">
                  {{ $t("select_dev_users_group") }}
                </p>
                <div class="row">
                  <div
                    class="col-sm-6"
                    v-click-outside.prevent="handleHideDevices"
                  >
                    <div class="">
                      <div
                        class="d-flex col-gap-3 mb-3 align-items-center toggle"
                      >
                        <span
                          :class="{ 'groups-btn': !isDeviceImei }"
                          @click="handleToggleGroup()"
                          class="cursor-pointer"
                        >
                          {{ $t("dev-name") }}
                        </span>
                        <span
                          :class="{ 'groups-btn': isDeviceImei }"
                          @click="handleToggleGroup()"
                          class="cursor-pointer"
                        >
                          {{ $t("device") }} {{ $t("imei") }}
                        </span>
                      </div>
                      <div class="position-relative">
                        <div class="search-icon">
                          <img
                            src="../../assets/images/Group 1237.png"
                            alt=""
                          />
                        </div>
                        <input
                          type="text"
                          name="group_name"
                          v-model="searchKey"
                          @input="doSearchCombo"
                          class="form-control"
                          :placeholder="$t('Search Devices by Name or IMEI')"
                          style="padding-left: 40px"
                          @focus="handleFocusDevices"
                        />
                      </div>
                    </div>
                    <div
                      style="height: 11rem; overflow-y: scroll"
                      class="data-table-bg p-3"
                      v-show="showDevices"
                    >
                      <ul class="pl-0">
                        <li
                          class="d-flex col-gap-1 mb-1"
                          v-for="(device, i) in selectedArr"
                          :key="device.id"
                        >
                          <input
                            type="checkbox"
                            :value="device.id"
                            checked
                            style="margin-top: 6px"
                            @change="updateUnselected(device, i)"
                            :id="device.id"
                          />
                          <div style="display: grid">
                            <label class="cursor-pointer mb-0" :for="device.id">
                              {{ isDeviceImei ? device.imei : device.name }}
                            </label>
                            <span class="gray4">{{ device.deviceTag }}</span>
                          </div>
                        </li>
                        <hr v-show="selectedArr.length > 0" />
                        <div v-if="filteredDevices.length > 0">
                          <li
                            class="d-flex col-gap-1 mb-2"
                            v-for="(device, i) in filteredDevices"
                            :key="device.id"
                          >
                            <input
                              type="checkbox"
                              :value="device"
                              @change="updateSelected(device, i)"
                              :id="device.id"
                              class="cursor-pointer"
                              style="margin-top: 6px"
                              :checked="false"
                            />
                            <div style="display: grid">
                              <label
                                :for="device.id"
                                class="cursor-pointer mb-0"
                              >
                                {{
                                  isDeviceImei
                                    ? device.imei
                                    : device.settings.name
                                }}
                              </label>
                              <span class="gray4">{{ device.deviceTag }}</span>
                            </div>
                          </li>
                        </div>
                        <div v-else>
                          {{ $t("No device found") }}
                        </div>
                      </ul>
                    </div>
                  </div>
                  <div
                    class="col-sm-6"
                    v-click-outside.prevent="handleHideUsers"
                  >
                    <div class="">
                      <label style="padding: 3px 16px" class="mb-3">{{
                        $t("users")
                      }}</label>
                      <div class="position-relative">
                        <div class="search-icon">
                          <img
                            src="../../assets/images/Group 1237.png"
                            alt=""
                          />
                        </div>
                        <input
                          type="text"
                          name="group_user"
                          v-model="searchKeyUser"
                          @input="doSearchUser"
                          class="form-control"
                          placeholder="Search Users"
                          style="padding-left: 40px"
                          @focus="handleFocusUsers"
                        />
                      </div>
                    </div>
                    <div
                      class="data-table-bg p-3"
                      style="height: 11rem; overflow-y: scroll"
                      v-show="showUsers"
                    >
                      <ul class="pl-0">
                        <li
                          class="d-flex col-gap-1 mb-1"
                          v-for="(user, i) in selectedArrUser"
                          :key="user.id"
                        >
                          <input
                            type="checkbox"
                            :value="user.id"
                            checked
                            style="margin-top: 6px"
                            @change="updateUnselectedUser(user, i)"
                            :id="user.id"
                          />
                          <div style="display: grid">
                            <label :for="user.id" class="cursor-pointer mb-0">
                              {{ user.fullname }}
                            </label>
                            <span class="gray4">{{ user.email }}</span>
                          </div>
                        </li>
                        <hr v-show="selectedArrUser.length > 0" />
                        <div v-if="filteredUsers.length > 0">
                          <li
                            class="d-flex col-gap-1 mb-2"
                            v-for="(user, i) in filteredUsers"
                            :key="user.id"
                          >
                            <input
                              type="checkbox"
                              :value="user"
                              @change="updateSelectedUser(user, i)"
                              :id="user.id"
                              class="cursor-pointer"
                              style="margin-top: 6px"
                              :checked="false"
                            />
                            <div style="display: grid">
                              <label :for="user.id" class="cursor-pointer mb-0">
                                {{ user.fullname }}
                              </label>
                              <span class="gray4">{{ user.email }}</span>
                            </div>
                          </li>
                        </div>
                        <div v-else>
                          {{ $t("no-user-found") }}
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="row mt-5">
                  <div class="col-lg-12">
                    <div class="d-flex col-gap-1 justify-content-end">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click="showTable = false"
                      >
                        {{ $t("cancel") }}
                      </button>
                      <button type="submit" class="btn btn-primary">
                        {{ $t("create") }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer text-center">
        &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
      </footer>
      <!-- ============================================================== -->
      <!-- End footer -->
      <!-- ============================================================== -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import AddGroup from "../Modals/AddGroup";
import NotificationBox from "../../components/NotificationBox.vue";
import tableMixin from "../../mixins/tableMixinWithBackend";
import Pagination from "../../components/PaginationNew.vue";
import TableSearch from "../../components/TableSearch.vue";
import warehouse from "../../assets/images/house.svg";
import truck from "../../assets/images/truck.svg";
import reefers from "../../assets/images/reefer.svg";
import SuccessModal from "../Modals/SuccessModal.vue";
import ConfirmModal from "../Modals/ConfirmModal.vue";

export default {
  name: "Groups",
  data() {
    return {
      group_name: "",
      group_description: "",
      minTemperature: "",
      maxTemperature: "",
      minHumidity: "",
      maxHumidity: "",
      mssg: "",
      tempmssg: "",
      humimssg: "",
      Errormssg: "",
      isOpen: false,
      isLoading: true,
      fullPage: true,
      activegroups: [],
      addGroupModal: false,
      filteredDevices: [],
      filteredUsers: [],
      searchKey: "",
      searchKeyUser: "",
      selectedArr: [],
      selectedArrUser: [],
      checked: false,
      showStep2: false,
      showStep3: false,
      step1Payload: null,
      isDeviceImei: false,
      searchKeyGroup: "",
      clonedgroups: [],
      showTable: false,
      capacity: "",
      others: "",
      storage: "",
      storageTypes: [
        {
          name: "Ware House",
          value: "warehouse",
          img: warehouse,
        },
        {
          name: "Truck",
          value: "truck",
          img: truck,
        },
        {
          name: "Reefers",
          value: "reefers",
          img: reefers,
        },
        {
          name: "Others",
          value: "others",
        },
      ],
      showDropdown: false,
      dropDownName: "",
      showDevices: false,
      showUsers: false,
      showSuccessPopup: false,
      usersLimit: null,
      devicesLimit: null,

      showConfirm: false,
      checkedGroup: [],
      showOopsModal: false,
      successMsg: "",
      successHeading: "",
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mounted() {
    this.handleGroupChange(this.params);

    this.fetchallDevices().then(() => {
      this.filteredDevices = this.devices.filter((item) => !item.group);
    });
    this.getUsers().then(() => {
      this.filteredUsers = this.users;
    });
    // this.$toasted.global.default("Toasted !!!", {
    //   type: "success",
    // });
  },
  components: {
    Loading,
    AddGroup,
    NotificationBox,
    Pagination,
    TableSearch,
    SuccessModal,
    ConfirmModal,
  },
  mixins: [tableMixin],
  watch: {
    groups: {
      handler: function () {
        this.initialiseGroups();
      },
      deep: true,
    },
    activegroups: {
      handler: function () {
        this.dataTable = this.activegroups;
      },
      deep: true,
    },
    storage: {
      handler: function () {
        if (this.storage === "others") return;
        this.others = "";
      },
    },
    capacity: {
      handler: function () {
        console.log(this.capacity);
        console.log(this.alphanumeric(this.capacity), "capacity");
      },
    },
    params() {
      this.handleGroupChange(this.params);
    },
  },
  computed: {
    ...mapGetters([
      "groups",
      "profile",
      "devices",
      "users",
      "groupsMeta",
      "canPerformAction",
    ]),
    paginationMeta() {
      return this.groupsMeta;
    },
    isAllChecked() {
      return (
        this.activegroups.length > 0 &&
        this.checkedGroup.length === this.activegroups.length
      );
    },
    email() {
      console.log(this.profile.email);
      return this.profile?.email;
    },
  },
  methods: {
    ...mapActions([
      "fetchGroups",
      "addGroup",
      "fetchallDevices",
      "updatePageNumber",
      "getUsers",
      "updateSelectedId",
      "downloadGroupReport",
    ]),
    handleSuccessPopup({ msg, heading }) {
      this.successMsg = msg;
      this.successHeading = heading;
      this.showSuccessPopup = true;
    },
    handleCheck(id) {
      if (event.target.checked) {
        if (!this.checkedGroup.includes(id)) {
          this.checkedGroup.push(id);
        }
      } else {
        const index = this.checkedGroup.indexOf(id);
        if (index > -1) {
          this.checkedGroup.splice(index, 1);
        }
      }
      this.updateSelectedId(this.checkedGroup);
    },
    headingCheckClick(event) {
      if (event.target.checked) {
        this.checkedGroup = this.activegroups.map((group) => group.id);
      } else {
        this.checkedGroup = [];
      }
      this.updateSelectedId(this.checkedGroup);
    },
    doStart() {
      console.log("Downloading shipments:", this.checkedGroup);
      this.isLoading = true;
      const downloadedReport = {
        groupIds: this.checkedGroup,
      };
      this.downloadGroupReport(downloadedReport)
        .then((res) => {
          this.isLoading = false;
          this.showConfirm = false;
          this.clearSelections();
          this.showSuccessPopup = true;
          this.successMsg = this.$t("download_file_msg", {
            email: this.email,
          });
          this.successHeading = this.$t("download_file_heading");
        })
        .catch((error) => {
          console.error("Error downloaing file:", error);
          this.isLoading = false;
          this.Errormssg = "Error downloaing file. Please try again.";
        });
    },
    clearSelections() {
      this.checkedGroup = [];
      this.updateSelectedId(this.checkedGroup);
    },
    downloadreport() {
      if (!this.checkedGroup || this.checkedGroup.length === 0) {
        this.showOopsModal = true;
        this.showConfirm = false;
      } else this.showConfirm = true;
    },
    handleHideDevices() {
      this.showDevices = false;
    },
    handleFocusDevices() {
      this.showDevices = true;
    },
    handleHideUsers() {
      this.showUsers = false;
    },
    handleFocusUsers() {
      this.showUsers = true;
    },
    alphanumeric(inputtxt) {
      let letterNumber = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
      return !!inputtxt.match(letterNumber);
    },
    initialiseGroups() {
      this.activegroups = this.groups;
    },
    gotogroup(id) {
      this.$router.push(`groups/${id}`);
    },
    updateFiltered() {
      const selectedIds = this.selectedArr.map(({ id }) => id);
      let devices = this.devices.filter((item) => !item.group);
      let notSelected = devices.filter(
        (item) => !selectedIds.includes(item.id)
      );
      this.filteredDevices = notSelected;
    },
    updateFilteredUser() {
      const selectedIds = this.selectedArrUser.map(({ id }) => id);
      let notSelected = this.users.filter(
        (item) => !selectedIds.includes(item.id)
      );
      this.filteredUsers = notSelected;
    },
    updateSelected({ id, settings: { name }, deviceTag, imei }) {
      this.selectedArr = [...this.selectedArr, { id, name, deviceTag, imei }];
      // this.updateFiltered();
      if (this.searchKey) {
        this.doSearchCombo();
      } else this.updateFiltered();
      const input = document.getElementById(`${id}`);
      input.checked = false;
    },
    updateUnselected(item, i) {
      let temp = [...this.selectedArr];
      temp.splice(i, 1);
      this.selectedArr = temp;
      // this.updateFiltered();
      if (this.searchKey) {
        this.doSearchCombo();
      } else this.updateFiltered();
      const input = document.getElementById(`${item.id}`);
      input.checked = true;
    },
    updateSelectedUser({ id, fullname, email }) {
      this.selectedArrUser = [...this.selectedArrUser, { id, fullname, email }];
      // this.updateFiltered();
      if (this.searchKeyUser) {
        this.doSearchUser();
      } else this.updateFilteredUser();
      // const input = document.getElementById(`${id}`);
      // input.checked = false;
    },
    updateUnselectedUser(item, i) {
      let temp = [...this.selectedArrUser];
      temp.splice(i, 1);
      this.selectedArrUser = temp;
      // this.updateFiltered();
      if (this.searchKeyUser) {
        this.doSearchUser();
      } else this.updateFilteredUser();
      // const input = document.getElementById(`${item.id}`);
      // input.checked = true;
    },
    doSearchCombo() {
      const selectedIds = this.selectedArr.map(({ id }) => id);
      let newData;
      newData = this.devices.filter(
        (device) =>
          (device.settings.name
            .toLowerCase()
            .includes(this.searchKey.toLowerCase()) ||
            device.imei.toLowerCase().includes(this.searchKey.toLowerCase())) &&
          !selectedIds.includes(device.id)
      );
      this.filteredDevices = newData;
    },
    doSearchUser() {
      const selectedIds = this.selectedArrUser.map(({ id }) => id);
      let newData;
      newData = this.users.filter(
        (user) =>
          user.fullname
            .toLowerCase()
            .includes(this.searchKeyUser.toLowerCase()) &&
          !selectedIds.includes(user.id)
      );
      this.filteredUsers = newData;
    },
    updateGroup(payload) {
      this.step1Payload = payload;
      this.addGroupModal = false;
      this.showStep2 = true;
    },
    submitDevices() {
      this.showStep2 = false;
      this.showStep3 = true;
    },
    goBack1() {
      this.showStep2 = false;
      this.addGroupModal = true;
    },
    createGroup() {
      this.isLoading = true;
      const storage = () => {
        let storage;
        if (this.storage === "others") {
          storage = this.others;
        } else storage = this.storage;

        return storage;
      };
      const newgroup = {
        name: this.group_name,
        // storage: storage(),
        // capacity: this.capacity,
        // minHumidity: this.minHumidity,
        // minTemperature: this.minTemperature,
        // maxHumidity: this.maxHumidity,
        // maxTemperature: this.maxTemperature,
        // devicesLimit: this.devicesLimit,
        // usersLimit: this.usersLimit,
      };
      let payload = {
        ...newgroup,
        devices: this.selectedArr.map(({ id }) => id),
        users: this.selectedArrUser.map(({ id }) => id),
      };
      this.addGroup(payload)
        .then((res) => {
          this.fetchGroups({ id: this.$route.params.id }).then(() => {
            this.showTable = false;
            this.showSuccessPopup = true;
            this.isLoading = false;
          });
          this.mssg =
            res.data.message[0].toUpperCase() + res.data.message.slice(1);
          setTimeout(() => {
            this.mssg = "";
          }, 4000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          setTimeout(() => {
            this.Errormssg = "";
          }, 4000);
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    goBack2() {
      this.showStep2 = true;
      this.showStep3 = false;
    },
    handleToggleGroup() {
      this.isDeviceImei = !this.isDeviceImei;
    },
    doSearchGroups({ target: { value } }) {
      const searchQuery = value;
      const groups = () => {
        if (this.profile.role === "admin") {
          return this.groups;
        } else {
          return this.groups.filter((group) =>
            group.users.includes(this.profile.id)
          );
        }
      };
      let newData;
      const filteredByDevicesName = this.devices
        .filter(
          ({ imei, settings: { name } }) =>
            name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            imei.toLowerCase().includes(searchQuery.toLowerCase())
        )
        .map(({ imei }) => imei);
      newData = groups().filter((group) => {
        return (
          group.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          group.devices.some((imei) => filteredByDevicesName.includes(imei))
        );
      });
      this.activegroups = searchQuery.length > 0 ? newData : groups();
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    handleGroupChange(params) {
      this.isLoading = true;
      this.fetchGroups(params)
        .then(() => {
          this.initialiseGroups();
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    doSearch() {
      let params = {
        ...this.params,
        keyword: this.searchQuery,
      };
      this.handleGroupChange(params);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== "DeviceDetails")
      this.updatePageNumber({
        lastPageNumber: 1,
        lastPage: ``,
        lastPageName: "",
      });
    next();
  },
};
</script>

<style scoped>
td {
  /* border-bottom: 1px rgba(0, 0, 0, 0.1) solid; */
}

th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="checkbox"]:checked {
  accent-color: #213e7a;
}
/* input[type="text"]::placeholder{
  padding-left: 20px;
} */
/* input[type="text"] {
  padding-left: 37px;
} */

.search-icon {
  position: absolute;
  left: 0.8rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.groups-btn {
  background: #dee2eb;
  border-radius: 30px;
}
.toggle span {
  color: #213e7a;
  padding: 3px 16px;
  font-size: 13px;
}
.search-container {
  display: flex;
  justify-content: end;
  align-items: center;
  flex-basis: 40%;
  width: 40%;
  margin-left: auto;
}
.search-container input {
  border-left: none;
  border-right: none;
}

.search-container input:focus {
  outline: none;
  border-top: 1px solid #dadfe2;
  border-bottom: 1px solid #dadfe2;
}

.storage-dropdown ul {
  list-style: none;
  padding: 0;
  z-index: 2;
}
.storage-dropdown li {
  border: 0.2px solid #8f8b8b;
  box-sizing: border-box;
  border-radius: 2px 2px 0px 0px;
  background-color: #e0e0e0;
}
.storage-dropdown li:hover {
  background: #bdbdbd;
}

.storage-dropdown li.active {
  background: #bdbdbd !important;
}

.upload_download {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 14px;
  font-weight: 600;
  color: rgba(33, 62, 122, 1);
  margin-right: 2rem;
  border-radius: 16px;
  cursor: pointer;
  border: 1px solid rgba(33, 62, 122, 1);
  padding: 12px 30px 12px;
}
input[type="checkbox"] {
  position: relative;
  width: 20px;
  height: 20px;
  /* appearance: none;
  -webkit-appearance: none; */
  /* background-color: rgba(255, 255, 255, 1); */
  border: 2px solid rgba(153, 153, 153, 1);
  border-radius: 6px;
  cursor: pointer;
  accent-color: #213e7a;
}

@media (max-width: 500px) {
  .search-container {
    width: 100%;
  }
}
@media (max-width: 769px) {
  .search-container {
    width: 60%;
  }
}
</style>

<i18n>
{
	"en": {
		"Add Devices": "Add Devices",
		"Add Users": "Add Users",
		"Back": "Back",
		"Create Group": "Create Group",
		"Device IMEI": "Device IMEI",
		"Device Name": "Device Name",
		"Devices": "Devices",
		"Next": "Next",
		"No User found": "No User found",
		"No device found": "No device found",
		"Search Devices by Name or IMEI": "Search Devices by Name or IMEI",
		"Search Users": "Search Users",
		"Users": "Users",
		"avg_humid": "Avg. Humidity",
		"avg_temp": "Avg. Temp",
		"group_monitor": "Schedule and monitor your devices as a group. Create a group to get started.",
		"group_name": "Group Name",
		"new_group": "New Group",
		"no_dev": "No device added",
		"no_group_yet": "You have no groups yet",
		"no_user": "No user added",
		"num_dev": "Number of Devices",
		"num_users": "Number of Users",
		"ur_groups": " Your groups will show here when the Admin assigns you to a Group."
	},
	"es": {
		"Add Devices": "Agregar dispositivos",
		"Add Users": "Agregar Usuarios",
		"Back": "atrás",
		"Create Group": "Crea un grupo",
		"Device IMEI": "IMEI del dispositivo",
		"Device Name": "Nombre del dispositivo",
		"Devices": "Dispositivos",
		"Next": "Siguiente",
		"No User found": "Usuario no encontrado",
		"No device found": "Ningún dispositivo encontrado",
		"Search Devices by Name or IMEI": "Buscar dispositivos por nombre o IMEI",
		"Search Users": "Buscar usuarios",
		"Users": "Usuarios",
		"avg_humid": "Promedio Humedad",
		"avg_temp": "Promedio Temperatura",
		"group_monitor": "Programe y controle sus dispositivos como grupo. Crea un grupo para empezar.",
		"group_name": "Nombre del grupo",
		"new_group": "Nuevo grupo",
		"no_dev": "Ningún dispositivo agregado",
		"no_group_yet": "Aún no tienes grupos",
		"no_user": "Ningún usuario agregado",
		"num_dev": "Numero de dispositivos",
		"num_users": "Número de usuarios",
		"ur_groups": " Tus grupos se mostrarán aquí cuando el administrador te asigne a un grupo."
	},
	"fr": {
		"Add Devices": "Ajouter des appareils",
		"Add Users": "Ajouter des utilisateurs",
		"Back": "Retour",
		"Create Group": "Créer un groupe",
		"Device IMEI": "IMEI de l'appareil",
		"Device Name": "Nom de l'appareil",
		"Devices": "Appareils",
		"Next": "Suivant",
		"No User found": "Aucun utilisateur trouvé",
		"No device found": "Aucun appareil trouvé",
		"Search Devices by Name or IMEI": "Rechercher des appareils par nom ou IMEI",
		"Search Users": "Rechercher des utilisateurs",
		"Users": "utilisateurs",
		"avg_humid": "Moyenne. Humidité",
		"avg_temp": "Moy. Temp",
		"group_monitor": "Regroupez et surveillez un groupe sélectionné d'appareils dans une seule vue, instantanément. Créez un groupe pour commencer.",
		"group_name": "Nom de groupe",
		"new_group": "Nouveau groupe",
		"no_dev": "Aucun appareil ajouté",
		"no_group_yet": "Vous n'avez pas encore de groupes",
		"no_user": "Aucun utilisateur ajouté",
		"num_dev": "Nombre d'appareils",
		"num_users": "Nombre d'utilisateurs",
		"ur_groups": "Vos groupes s'afficheront ici lorsque l'administrateur vous affectera à un groupe."
	},
	"sw": {
		"Add Devices": "Ongeza Vifaa",
		"Add Users": "Ongeza Watumiaji",
		"Back": "Rudi",
		"Create Group": "Unda kikundi",
		"Device IMEI": "IMEI ya kifaa",
		"Device Name": "Jina la kifaa",
		"Devices": "Vifaa",
		"Next": "Ifuatayo",
		"No User found": "Hakuna mtumiaji aliyepatikana",
		"No device found": "Hakuna Kifaa Kilichopatikana",
		"Search Devices by Name or IMEI": "Tafuta Vifaa kwa Jina au IMEI",
		"Search Users": "Tafuta Watumiaji",
		"Users": "Watumiaji",
		"avg_humid": "Wastani. Unyevu",
		"avg_temp": "Wastani. Muda",
		"group_monitor": "Ratibu na ufuatilie vifaa vyako kama kikundi. Unda kikundi ili uanze.",
		"group_name": "Jina la kikundi",
		"new_group": "Kikundi kipya",
		"no_dev": "Hakuna kifaa kilichoongezwa",
		"no_group_yet": "Bado huna vikundi",
		"no_user": "Hakuna mtumiaji aliyeongezwa",
		"num_dev": "Idadi ya Vifaa",
		"num_users": "Idadi ya Watumiaji",
		"ur_groups": " Vikundi vyako vitaonekana hapa Msimamizi atakapokukabidhi kwa Kikundi."
	}
}
</i18n>
